import jsPDF from "jspdf";
import "jspdf-autotable";
import { createI18n } from "vue-i18n";
import en from "@/i18n/locales/en";
import id from "@/i18n/locales/id";
import my from "@/i18n/locales/my";
import { getDataSessionStorage } from "@/app/infrastructures/misc/SessionStorage";

let i18nInstance: any;
let translate: any;

const generateInHubSummary = async (
  title: string,
  data: { name: string; value: any }[],
  logo: string
) => {
  i18nInstance = createI18n({
    legacy: false,
    locale: getDataSessionStorage("countryCode") || "id",
    fallbackLocale: "id",
    globalInjection: false,
    messages: {
      en,
      id,
      my
    }
  });
  translate = i18nInstance.global.t;

  const doc = new jsPDF("p", "mm", "a5", true);
  let y = 6;

  const pdfWidth = doc.internal.pageSize.width;
  const logoProperties = doc.getImageProperties(logo);
  const logoAspectRatio = logoProperties.height / logoProperties.width;

  const imageWidth = 40;
  const imageHeight = logoAspectRatio * 40;
  doc.addImage(
    logo,
    "PNG",
    pdfWidth - imageWidth - 9,
    y,
    imageWidth,
    imageHeight,
    "logo",
    "FAST",
    0
  );
  doc.setFont("Montserrat", "bold");
  doc.setFontSize(12);
  doc.setTextColor("#4d4d4d");

  y += 7;
  doc.text(title, 10, y);
  doc.setFillColor("#e0e0e0");
  doc.rect(10, 20, 130, 0.2, "F");

  y += 20;
  doc.setFont("Montserrat", "normal");
  doc.setFontSize(12);
  doc.setTextColor("#4d4d4d");
  const columnWidth = doc.internal.pageSize.width / 2 - 15;
  let leftY = y;
  let rightY = y;

  for (const [index, item] of data.entries()) {
    const isLeftColumn = index % 2 === 0;
    const currentY = isLeftColumn ? leftY : rightY;
    const xPosition = isLeftColumn ? 10 : columnWidth + 25;
    doc.setFont("Montserrat", "normal");
    doc.text(item.name, xPosition, currentY);
    doc.setFont("Montserrat", "bold");
    doc.text(`${item.value}`, xPosition, currentY + 7);

    if (isLeftColumn) {
      leftY += 21;
    } else {
      rightY += 21;
    }
    y = Math.max(leftY, rightY);
  }

  y = 175;
  doc.setFont("Montserrat", "normal");
  doc.setFontSize(10);
  doc.text(translate("hubToHub.adminStaff"), 10, y);
  doc.text(translate("hubToHub.courier"), 65, y);
  doc.text(translate("hubToHub.operationsSupervisor"), 110, y);

  y += 27;
  doc.setFontSize(8);
  doc.text("(................................)", 10, y);
  doc.text("(................................)", 60, y);
  doc.text("(................................)", 110, y);

  doc.setProperties({
    title
  });
  doc.autoPrint();
  window.open(doc.output("bloburl").toString(), "_blank");
};

export default generateInHubSummary;
